define(
    [
        './ActionMessage',
        './BulletList',
        './Breadcrumbs',
        './Row'
    ],
    function () {
        //Layouts definitions return a string module name
        //Apply those as dependencies
        return angular.module('edge.platform.widgets.layouts', Array.prototype.slice.call(arguments));
    }
);



// WEBPACK FOOTER //
// ../common/js/src/edge/platform/widgets/layouts/module.js